import { GridColDef } from '@mui/x-data-grid';
import moment from 'moment';
import { ViewButton } from '../../Buttons/ViewButton';
import { EditButton } from '../../Buttons/EditButton';
import { DeleteButton } from '../../Buttons/DeleteButton';
import { INavigationContent } from '../../../types/store';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { CommonButton } from '../../Buttons';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export const getNavigationColumns = (
  onClickDelete: Function,
  onClickEdit: Function,
  onClickView: Function,
  onClickAddSubpage: Function,
): GridColDef[] => {
  return [
    {
      field: 'display_order',
      headerName: 'Display Order',
      flex: 0.6,
    },
    {
      field: 'title',
      headerName: 'Page',
      flex: 1,
    },
    {
      field: 'route',
      headerName: 'Route',
      flex: 1.2,
    },
    {
      field: 'children',
      headerName: 'Subpages',
      flex: 1.3,
      renderCell: (params) => {
        const children = (params.row.children as INavigationContent[]) ?? [];
        if (!children.length) return <span style={{ color: '#aaa' }}>—</span>;

        return (
          <Box display="flex" flexDirection="column" gap={0.25} py={0.5}>
            {children.map((c) => (
              <Box key={c.id} display="flex" alignItems="center" gap={0.5}>
                <Tooltip title={c.route} arrow>
                  <Typography variant="caption" fontWeight={500} noWrap sx={{ maxWidth: 120 }}>
                    {c.title}
                  </Typography>
                </Tooltip>
                <IconButton size="small" onClick={() => onClickEdit(c)}>
                  <EditIcon sx={{ fontSize: 13 }} />
                </IconButton>
                <IconButton size="small" onClick={() => onClickDelete(c.id)}>
                  <DeleteIcon sx={{ fontSize: 13 }} />
                </IconButton>
              </Box>
            ))}
          </Box>
        );
      },
    },
    {
      field: 'created_at',
      headerName: 'Created At',
      renderCell: (params) => {
        const data = params.row.created_at;
        return (
          <>
            <span>
              {moment(data).isValid() ? moment(data).format('MMMM Do YYYY, h:mm:ss a') : ''}
            </span>
          </>
        );
      },
      flex: 1.8,
      minWidth: 200,
    },
    {
      field: 'updated_at',
      headerName: 'Updated At',
      renderCell: (params) => {
        const data = params.row.updated_at;
        return (
          <>
            <span>
              {moment(data).isValid() ? moment(data).format('MMMM Do YYYY, h:mm:ss a') : ''}
            </span>
          </>
        );
      },
      flex: 1.8,
      minWidth: 200,
    },
    {
      field: 'actions',
      headerName: 'Actions',
      renderCell: (params) => {
        return (
          <>
            <ViewButton onClick={() => onClickView(params.row)} />
            <EditButton onClick={() => onClickEdit(params.row)} />
            <DeleteButton onClick={() => onClickDelete(params.row.id)} />
            <CommonButton label={'Add Subpage'} onClick={() => onClickAddSubpage(params.row)} />
          </>
        );
      },
      flex: 1.5,
      minWidth: 180,
    },
  ];
};
